var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5 18.3332C4.30556 18.3332 3.71528 18.0901 3.22917 17.604C2.74306 17.1179 2.5 16.5276 2.5 15.8332V13.3332H5V1.6665H17.5V15.8332C17.5 16.5276 17.2569 17.1179 16.7708 17.604C16.2847 18.0901 15.6944 18.3332 15 18.3332H5ZM15 16.6665C15.2361 16.6665 15.434 16.5866 15.5938 16.4269C15.7535 16.2672 15.8333 16.0693 15.8333 15.8332V3.33317H6.66667V13.3332H14.1667V15.8332C14.1667 16.0693 14.2465 16.2672 14.4062 16.4269C14.566 16.5866 14.7639 16.6665 15 16.6665ZM7.5 7.49984V5.83317H15V7.49984H7.5ZM7.5 9.99984V8.33317H15V9.99984H7.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditions);
export default __webpack_public_path__ + "static/media/conditions.112d01a00b115150925e0a81a17b945b.svg";
export { ForwardRef as ReactComponent };